<template>
    <section  class="cv_long" v-b-toggle.collapse_long v-scroll-to="'#collapse_long'" tabindex="0" role="tab">
        <div class="container">
            <h1>Detailed account...</h1>
            <article class="long">
                <h5>...of my journey from philosophy to programming</h5>
            </article>
        </div>
    </section>
</template>

<script>
    export default {
        name: "CV-Long",
    }
</script>

<style scoped>
    .cv_long {
        height: 50vh;
        background-image: url("../../assets/keyboard.jpg");
        background-size: cover;
        background-position: center;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        transition: filter 0.5s ease;
        filter: grayscale(100%);
        outline: none;
    }
    .container{
        height: 50vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    h1 {
        font-size: 4vmax;
        font-weight: 700;
        color: white;
        text-shadow: 0 0 15px yellow;
    }
    h5 {
        color: white;
        text-shadow: 0 0 15px blue;
        font-size: 2vmax;
        padding-top: 20px;
    }
/*    check _app*/
</style>